
<template>
  <div>
    <VueCtkDateTimePicker
      :disabled="isDisabled"
      input-size="sm"
      format="YYYY/MM/DD HH:mm"
      output-format="YYYY/MM/DD HH:mm"
      formatted="YYYY/MM/DD HH:mm"
      color="#3b89cb"
      :id="fieldID"
      :name="fieldID"
      :label="null"
      :no-label="true"
      :inline="false"
      locale="ja-jp"
      v-model="localModel"
      button-now-translation="今"
      :no-value-to-custom-elem="true"
      class=" input-group force-white"
    >
      <span
        :disabled="isDisabled"
        class="calendar-test input-group-addon btn"
        :style="inputStyle + 'padding: 0px 8px !important'"
        ><i class="glyphicon glyphicon-calendar"></i
      ></span>
      <div class="input-group">
        <input
          :disabled="isDisabled"
          class="form-control form-control"
          type="text"
          :style="inputStyle + 'height: 25px !important; marging: 2px; border-radius: 0px'"
          v-model="localModel"
        />
        <span
          :disabled="isDisabled"
          class="calendar-test input-group-addon btn"
          :style="inputStyle + 'padding: 0px 8px !important'"
          @click="clearCalendar"
          ><i class="glyphicon glyphicon-remove"></i
        ></span>
      </div>
    </VueCtkDateTimePicker>
  </div>
</template>

<script>
import moment from 'moment';
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "../../../static/local/vue-ctk-date-time-picker.css";



export default {
  components: {
    VueCtkDateTimePicker: VueCtkDateTimePicker,
  },
  data() {
    return {
      local_model: null,
      disable_in_value:false
    };
  },
  watch: {
    inValue: (value) => {
      setTimeout(() => {
        
        // this.localModel = value;
      }, 100);
    }
  },
  computed: {
    fieldID(){
      return this.$props.id;
    },
    inValue(){
      if(this.$props.value && this.$props.value.indexOf("nvalid") > -1){
        return null;
      }
      if(this.disable_in_value == false){
        this.local_model = this.$props.value;
      }
      
      return this.$props.value;
    },
    localModel: {
      get() {
        return this.local_model;
      },
      set(v) {
        this.disable_in_value = true;
        this.$emit("input",v)
        this.local_model = v;
      },
    },
    isDisabled() {
      return this.$props.disabled == true;
    }
  },
  methods: {
    clearCalendar(){
      if(this.isDisabled){
        return;
      }
      this.localModel = null;
    },
  },
  mounted() {



  },
  props: ["disabled","value","id","inputStyle"],
};
</script>

<style >
.header-picker{
  display: none;
}
</style>



// WEBPACK FOOTER //
// Datetimepicker2.vue?66973c69